module.exports = __webpack_public_path__ + "img/dash-vertical.675653f.svg";